<ng-template #bulkList>
    <ng-content select="[climbDropdownItem]"></ng-content>
</ng-template>

<climb-dropdown data-automation-id="bulk-dropdown"
                caption="Bulk"
                [icon]="icons.stack">
    <ng-container [ngTemplateOutlet]="bulkList"></ng-container>
</climb-dropdown>
